<main class="tracking-scripts-page">
  <section class="tracking-scripts__container">
    <header class="tracking-scripts__header">
      <div>
        <h1>{{ 'trackingScripts.title' | translate }}</h1>
        <p>{{ 'trackingScripts.subtitle' | translate }}</p>
      </div>
      <button type="button"
              class="primary-btn"
              (click)="openCreatePanel()">
        {{ 'trackingScripts.actions.new' | translate }}
      </button>
    </header>


    <div class="tracking-scripts__filters surface-card">
      <div class="tracking-scripts__filter-field">
        <label>{{ 'trackingScripts.filters.search' | translate }}</label>
        <div class="tracking-scripts__filter-control">
          <input type="search"
                 [value]="searchTerm"
                 [placeholder]="'trackingScripts.filters.searchPlaceholder' | translate"
                 (input)="onSearch($any($event.target).value)">
          <button type="button"
                  class="ghost-btn compact"
                  *ngIf="searchTerm"
                  (click)="clearSearch()">×</button>
        </div>
      </div>
    </div>

    <div class="tracking-scripts__layout">
      <div class="tracking-scripts__card surface-card">
        <div class="tracking-scripts__table-wrapper">
          <div class="tracking-scripts__table-header" *ngIf="!isLoading && !loadingError && filteredConfigs.length">
            <span>{{ 'trackingScripts.table.name' | translate }}</span>
            <span>{{ 'trackingScripts.table.scripts' | translate }}</span>
            <span>{{ 'trackingScripts.table.providers' | translate }}</span>
            <span>{{ 'trackingScripts.table.status' | translate }}</span>
            <span class="tracking-scripts__header-spacer" aria-hidden="true"></span>
          </div>

          <div class="tracking-scripts__list">
            <p class="list-status" *ngIf="isLoading">{{ 'common.loading' | translate }}</p>
            <p class="list-status error" *ngIf="!isLoading && loadingError">{{ loadingError }}</p>

            <ng-container *ngIf="!isLoading && !loadingError && filteredConfigs.length; else emptyState">
              <div class="tracking-scripts__row" *ngFor="let config of paginatedConfigs">
                <span>
                  <div class="tracking-scripts__cell-title">{{ config.Name }}</div>
                  <div class="tracking-scripts__cell-subtitle">ID: {{ config.ID }}</div>
                </span>
                <span class="tracking-scripts__scripts-cell">{{ getScriptsLabel(config) }}</span>
                <span>
                  <div class="tracking-scripts__providers-cell">
                    <span class="tracking-scripts__provider-count">{{ config.Providers.length || 0 }}</span>
                    <ng-container *ngIf="config.Providers.length">
                      <ng-container *ngFor="let provider of config.Providers">
                        <button type="button"
                                class="deploy-badge"
                                [ngClass]="getDeployStatusClass(provider.DeployStatus)"
                                [title]="getDeployStatusLabel(provider.DeployStatus)"
                                (click)="openSnippetModal(config, provider)">
                          {{ getProviderName(provider.ProviderID) }}
                        </button>
                      </ng-container>
                    </ng-container>
                  </div>
                </span>
                <span>
                  <span class="status-badge" [ngClass]="config.Status === 1 ? 'status-badge--active' : 'status-badge--inactive'">
                    {{ config.Status === 1 ? ('trackingScripts.fields.statusActive' | translate) : ('trackingScripts.fields.statusInactive' | translate) }}
                  </span>
                </span>
                <div class="tracking-scripts__actions">
                  <button type="button"
                          class="tracking-scripts__action-trigger"
                          aria-haspopup="menu"
                          [attr.aria-expanded]="activeActionMenuId === config.ID"
                          (click)="toggleActionsMenu(config, $event)">
                    <svg viewBox="0 0 20 20" role="presentation" aria-hidden="true">
                      <circle cx="10" cy="4" r="1.5" />
                      <circle cx="10" cy="10" r="1.5" />
                      <circle cx="10" cy="16" r="1.5" />
                    </svg>
                  </button>
                </div>
              </div>
            </ng-container>

            <ng-template #emptyState>
              <p class="list-status" *ngIf="!isLoading && !loadingError && !filteredConfigs.length">
                {{ 'trackingScripts.empty' | translate }}
              </p>
            </ng-template>
          </div>
        </div>

        <div class="pagination-controls" *ngIf="!isLoading && filteredConfigs.length">
          <div class="page-size">
            <label>Rows per page</label>
            <select [value]="pageSize" (change)="changePageSize($event)">
              <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
            </select>
          </div>
          <div class="page-navigation">
            <button type="button"
                    class="ghost-btn"
                    (click)="goToPage(currentPage - 1)"
                    [disabled]="currentPage === 0">
              ‹
            </button>
            <span class="page-info">
              {{ currentPage + 1 }} / {{ totalPages }}
            </span>
            <button type="button"
                    class="ghost-btn"
                    (click)="goToPage(currentPage + 1)"
                    [disabled]="currentPage + 1 >= totalPages">
              ›
            </button>
          </div>
        </div>

        <ng-container *ngIf="activeActionItem as menuItem">
          <div class="tracking-scripts__action-menu"
               role="menu"
               [style.top.px]="actionMenuPosition.top"
               [style.left.px]="actionMenuPosition.left"
               [style.--tracking-scripts-action-arrow-left]="actionMenuArrowOffset + 'px'">
            <div class="tracking-scripts__action-menu-label">{{ 'trackingScripts.table.actions' | translate }}</div>
            <button type="button"
                    class="tracking-scripts__action-item"
                    (click)="openEditPanel(menuItem)">
              <span class="action-icon action-icon--edit" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <path d="M3 14.5V17h2.5L15.4 7.1l-2.5-2.5L3 14.5z" />
                  <path d="M12.2 4.1l2.5 2.5 1.4-1.4c.4-.4.4-1 0-1.4L14 2.2c-.4-.4-1-.4-1.4 0l-1.4 1.9z" />
                </svg>
              </span>
              <span>{{ 'trackingScripts.actions.edit' | translate }}</span>
            </button>
            <button type="button"
                    class="tracking-scripts__action-item"
                    [disabled]="isDeploying.has(menuItem.ID)"
                    (click)="toggleStatus(menuItem)">
              <span class="action-icon action-icon--toggle" aria-hidden="true">
                <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5">
                  <path d="M10 3v5" stroke-linecap="round"/>
                  <path d="M6.3 5.3A6 6 0 1 0 13.7 5.3" stroke-linecap="round"/>
                </svg>
              </span>
              <span>
                {{ menuItem.Status === 1 ? ('trackingScripts.actions.deactivate' | translate) : ('trackingScripts.actions.activate' | translate) }}
              </span>
            </button>
            <button type="button"
                    class="tracking-scripts__action-item"
                    [disabled]="isDeploying.has(menuItem.ID)"
                    (click)="deployConfig(menuItem)">
              <span class="action-icon action-icon--deploy" aria-hidden="true">
                <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5">
                  <path d="M10 14V2M6 6l4-4 4 4" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4 17h12" stroke-linecap="round"/>
                </svg>
              </span>
              <span>
                {{ isDeploying.has(menuItem.ID) ? ('trackingScripts.actions.deploying' | translate) : ('trackingScripts.actions.deploy' | translate) }}
              </span>
            </button>
            <button type="button"
                    class="tracking-scripts__action-item"
                    [disabled]="isPurging.has(menuItem.ID)"
                    (click)="purgeCdn(menuItem)">
              <span class="action-icon action-icon--purge" aria-hidden="true">
                <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5">
                  <path d="M4 10a6 6 0 1 1 1.5 4" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4 14v-4H8" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              <span>
                {{ isPurging.has(menuItem.ID) ? ('trackingScripts.purge.inProgress' | translate) : ('trackingScripts.purge.action' | translate) }}
              </span>
            </button>
            <button type="button" class="tracking-scripts__action-item danger" (click)="deleteConfig(menuItem)">
              <span class="action-icon action-icon--delete" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <path d="M6 6h8l-.8 10.5H6.8L6 6z" />
                  <path d="M4 5h12" />
                  <path d="M8 5V3h4v2" />
                </svg>
              </span>
              <span>{{ 'trackingScripts.actions.delete' | translate }}</span>
            </button>
          </div>
        </ng-container>
      </div>

      <div class="tracking-scripts__form-wrapper" *ngIf="panelOpen">
        <app-tracking-scripts-form
          #trackingScriptsForm
          [mode]="formMode"
          (saved)="handleFormSaved()"
          (cancelled)="closePanel()"
        ></app-tracking-scripts-form>
      </div>
    </div>
  </section>
</main>

<!-- Snippet modal -->
<div class="snippet-modal-overlay" *ngIf="snippetModal" (click)="closeSnippetModal()">
  <div class="snippet-modal" (click)="$event.stopPropagation()">

    <div class="snippet-modal__header">
      <div>
        <p class="snippet-modal__title">{{ 'trackingScripts.snippet.title' | translate }} — {{ snippetModal.providerName }}</p>
        <p class="snippet-modal__subtitle">ProviderID: {{ snippetModal.providerID }}</p>
      </div>
      <button type="button" class="ghost-btn compact" (click)="closeSnippetModal()">×</button>
    </div>

    <div class="snippet-modal__body">
      <pre class="snippet-modal__pre"><code>{{ snippetModal.script }}</code></pre>
    </div>

    <div class="snippet-modal__footer">
      <a *ngIf="snippetModal.gcsUrl"
         [href]="snippetModal.gcsUrl"
         target="_blank"
         rel="noopener noreferrer"
         class="snippet-modal__gcs-link">
        {{ 'trackingScripts.snippet.viewConfigJs' | translate }} →
      </a>
      <span *ngIf="!snippetModal.gcsUrl" class="snippet-modal__no-gcs">
        {{ 'trackingScripts.snippet.notDeployed' | translate }}
      </span>
      <button type="button" class="ghost-btn snippet-modal__icon-btn"
              [title]="'trackingScripts.snippet.download' | translate"
              (click)="downloadSnippet()">
        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M10 3v10m0 0l-3.5-3.5M10 13l3.5-3.5M3 16h14"/>
        </svg>
      </button>
      <button type="button" class="ghost-btn snippet-modal__icon-btn"
              [title]="(snippetCopied ? 'trackingScripts.snippet.copied' : 'trackingScripts.snippet.copyClipboard') | translate"
              (click)="copySnippet()">
        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
          <rect x="7" y="5" width="9" height="12" rx="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path stroke-linecap="round" stroke-linejoin="round" d="M13 5V4a1 1 0 00-1-1H5a1 1 0 00-1 1v10a1 1 0 001 1h2"/>
        </svg>
      </button>
    </div>

  </div>
</div>
